import React, {useState} from 'react'
import {Card, CardBody, CardTitle,  Nav, NavItem, NavLink,  TabContent, TabPane, Collapse, Row, Col} from 'reactstrap';
import classnames from 'classnames';
import moment from 'moment'
import StdTable from '../StdTable'
import { Trans } from "react-i18next";
import {ChevronDown, ChevronUp} from 'react-feather';


export default ({invoices}) => {
    const [isOpen, setOpened] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const icids = invoices.map(i => i.issuing_company_id)
    const issuing_companies = invoices.filter((value, index, self) => icids.indexOf(value.issuing_company_id) === index)
    return (<Card>

	<CardBody>
	    <CardTitle>
		<button onClick={() => setOpened(!isOpen) } className="content_button" style={{width: '100%'}}>
		    <Row>
			<Col>
			    <h2><Trans>companies.sections.invoices</Trans></h2>
			</Col>

			<Col  xs="auto">
			    {isOpen ? <ChevronUp /> : <ChevronDown />}
			</Col>
		    </Row>
		    
		</button>
		
	    </CardTitle>
	    
	    <Collapse  isOpen={isOpen} className="print">
		
		<Nav tabs>
		    {issuing_companies.map( (ic, index)=>
			<NavItem  key={ic.issuing_company_id}>
			    <NavLink className={classnames({ active: activeTab === index })} onClick={() => setActiveTab(index) }>
				{ic.issuing_company_name}
			    </NavLink>
			</NavItem>
		    )}
		</Nav>
		<TabContent activeTab={activeTab}>
		    {issuing_companies.map( (ic, index)=>
			<TabPane tabId={index} key={index}>
			    <StdTable collection={ invoices.filter((i) => i.issuing_company_id===ic.issuing_company_id ).sort((a,b) => moment(b.due_date).isBefore(moment(a.due_date)) ? 1 : -1) } fields={['document_id', {name: 'amount', type: 'currency'}, {name: 'leftover', type: 'currency'}, {name: 'issue_date', type: 'date'}, {name: 'due_date', type: 'date'}, 'close_date', 'accounting_year']} trans_prefix="invoices" collection_key="id" childs="installments" backgroundColor={({due_date}) => moment(due_date).isBefore(moment())  ? '#ffe6e6' : '#d9f2d9' } />
			    
			</TabPane>
		    )}
		</TabContent>
		
	    </Collapse>
	</CardBody>
    </Card>
    )}
